(function() {
    'use strict';

    let DatiUtenteCtrl = function(
        messaggiFctr,
        datiUtenteService,
        gestioneUtenteService
    ) {

        this.loading = 0;
        // this.categorieHomeBanking = [{
        //         cod: '',
        //         dsc: 'Non attivo'
        //     },
        //     {
        //         cod: 'I',
        //         dsc: 'Informativo'
        //     },
        //     {
        //         cod: 'S',
        //         dsc: 'Dispositivo'
        //     }
        // ];
        // this.categorieTrading = [{
        //         cod: '',
        //         dsc: 'Non attivo'
        //     },
        //     {
        //         cod: 'I',
        //         dsc: 'Informativo'
        //     },
        //     {
        //         cod: 'S',
        //         dsc: 'Dispositivo'
        //     }
        // ];
        this.dominiClassificazioneUtente = [{
                cod: 'NON_PROFESSIONAL',
                dsc: 'Non Professional'
            },
            {
                cod: 'PROFESSIONAL',
                dsc: 'Professional'
            }
        ];
        this.classificazioneUtente = null;
        this.ultimoAccessoMobile = null;
        this.ultimoAccessoWeb = null;
        this.gestioneUtenteService = gestioneUtenteService;

        this.init = () => {
            this.recuperaDominiMfWeb();
            this.recuperaStatiRaggiungibili();
            
            if (gestioneUtenteService.praticaPic.tipo != 'INSERIMENTO') {
                this.recuperaClassificazioneUtente();
                this.recuperaDateUltimiAccessi();
            }

            if (this.gestioneUtenteService.checkCampoObbligatorio('mito.hb') && !this.gestioneUtenteService.datiMito.hb) {
                this.gestioneUtenteService.datiMito.hb = '';
            }
            if (this.gestioneUtenteService.checkCampoObbligatorio('mito.tol') && !this.gestioneUtenteService.datiMito.tol) {
                this.gestioneUtenteService.datiMito.tol = '';
            }
        }

        this.recuperaDominiMfWeb = () => {
            datiUtenteService
                .recuperaDominiMfweb(gestioneUtenteService.datiMito.codiceUtente)
                .then(
                    (resp) => {
                        this.categorieMfweb = [];
                        this.categorieMfweb.push({ cod: 0, dsc: 'Non attivo' });
                        resp.data.result.forEach((categoria) => {
                            this.categorieMfweb.push({ cod: categoria.cod, dsc: categoria.dsc });
                        });
                    },
                    (error) => messaggiFctr.processaResponse(error)
                );
        };

        this.recuperaClassificazioneUtente = () => {
            datiUtenteService
                .recuperaClassificazioneUtente(gestioneUtenteService.datiMito.codiceUtente)
                .then(
                    (resp) => {
                        this.classificazioneUtente = resp.data.result.cod;
                    },
                    (error) => messaggiFctr.processaResponse(error)
                );
        };

        this.recuperaDateUltimiAccessi = () => {
            datiUtenteService
                .recuperaDateUltimiAccessi(gestioneUtenteService.datiMito.idUtente)
                .then(
                    (resp) => {
                        this.ultimoAccessoMobile = resp.data.result.ultimoAccessoMobile;
                        this.ultimoAccessoWeb = resp.data.result.ultimoAccessoWeb;
                    },
                    (error) => messaggiFctr.processaResponse(error)
                );
        };

        this.recuperaStatiRaggiungibili = () => {
            datiUtenteService
                .recuperaStatiRaggiungibili(gestioneUtenteService.datiMito.codiceUtente, gestioneUtenteService.praticaPic.idPratica)
                .then(
                    (resp) => {
                        this.dominiStato = resp.data.result;
                    },
                    (error) => messaggiFctr.processaResponse(error)
                );
        };

        this.checkObbligatorietaMfweb = () => {
            return !!this.gestioneUtenteService.datiMito.tol && (this.gestioneUtenteService.datiMito.tol != '');
        };

        this.ngRequiredHb = () => {
            // if (this.gestioneUtenteService.checkCampoObbligatorio('mito.hb') && !this.gestioneUtenteService.datiMito.hb) {
            //     this.gestioneUtenteService.datiMito.hb = '';
            // }
            return false;
        };

        this.ngRequiredTol = () => {
            // if (this.gestioneUtenteService.checkCampoObbligatorio('mito.tol') && !this.gestioneUtenteService.datiMito.tol) {
            //     this.gestioneUtenteService.datiMito.tol = '';
            // }
            return false;
        };

        this.init();
    };

    DatiUtenteCtrl.$inject = [
        'MitomMessaggiFctr',
        'MitomDatiUtenteService',
        'MitomGestioneUtenteService'
    ];

    let TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'mitoman-gestione-utente/mitoman-dati-utente-mito/mitoman-dati-utente/datiUtente.component.html'
        );
    };
    TemplateUrl.$inject = ['Mitom_CONSTANTS'];

    let DatiUtenteComponent = {
        controller: DatiUtenteCtrl,
        controllerAs: 'datiUtenteCtrl',
        templateUrl: TemplateUrl
    };

    angular
        .module('cbl.mitomanager.wa')
        .component('mitomdatiUtente', DatiUtenteComponent);
})();